import React from "react"

class GenericError extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.errorButtonAction = this.errorButtonAction.bind(this);
    this.reloadCheckout = this.reloadCheckout.bind(this);
    this.removeModal = this.removeModal.bind(this);
    this.goToContactUs = this.goToContactUs.bind(this);
  }
  errorButtonAction() {
    if (this.props.config.errorButtonAction !== null) {
      this.props.config.errorButtonAction();
      if (this.props.config.reloadCheckoutAfterErrorButtonAction === true) {
        this.reloadCheckout();
      }
    }
  }
  removeModal() {
    this.props.config.closeAction();
    if (this.props.config.reloadCheckoutAfterClose === true) {
      this.reloadCheckout();
    }
  }
  reloadCheckout() {
    window.location.href = this.props.config.checkoutUrl;
  }
  goToContactUs() {
    window.location.href = this.props.config.contactUrl;
  }
  render() {
    return (
      <div className="generic-error-wrapper">
        <div className="generic-error">
          <h1>
            {this.props.config.title}
            <span className="pull-right" onClick={this.removeModal}>
              Close <i className="icon-remove" />
            </span>
          </h1>
          <div className="body">
            {this.props.config.body}
            <div className="actions">
              {this.props.config.errorButton === true ? (
                <button
                  className="retry-payment"
                  onClick={this.errorButtonAction}
                >
                  {this.props.config.errorButtonTitle}
                </button>
              ) : (
                ""
              )}
              <button
                className="contact-us grey-button"
                onClick={this.goToContactUs}
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GenericError;
